import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import lockIcon from "assets/img/customer/lock.svg";
import { ReactNode, useContext, useEffect } from "react";
import { OrderMobilePrimaryActionContext } from "../layout/OrderLayout";
import { WizardStep } from "../types";

export default function StepShell(props: {
  title: string;
  description?: string;
  children: ReactNode;
  primaryLabel: string;
  onPrimary: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  isPrimaryDisabled?: boolean;
  isPrimaryLoading?: boolean;
  step?: WizardStep;
}) {
  const {
    title,
    description,
    children,
    primaryLabel,
    onPrimary,
    isPrimaryDisabled,
    isPrimaryLoading,
  } = props;

  const isActionDisabled = isPrimaryDisabled || isPrimaryLoading;

  const mobilePrimaryActionCtx = useContext(
    OrderMobilePrimaryActionContext,
  );

  useEffect(() => {
    if (!mobilePrimaryActionCtx) return;
    mobilePrimaryActionCtx.setAction({
      label: primaryLabel,
      onClick: onPrimary,
      isDisabled: isActionDisabled,
      isLoading: isPrimaryLoading,
    });

    return () => {
      mobilePrimaryActionCtx.setAction(null);
    };
  }, [
    mobilePrimaryActionCtx,
    primaryLabel,
    onPrimary,
    isActionDisabled,
    isPrimaryLoading,
  ]);

  return (
    <Flex
      flex={1}
      direction="column"
      minH="100%"
      bgColor="#FFF"
      rowGap="24px"
      w="100%"
      maxW={{ base: "100%", md: "556px" }}
      ml={{ base: "0", md: "auto" }}
    >
      <Box>
        <Heading fontSize="24px" fontWeight="600" color="#0B0E10">
          {title}
        </Heading>
        {description ? (
          <Text
            mt="6px"
            fontSize="16px"
            lineHeight="1.2"
            fontWeight="400"
            color="#505E70"
          >
            {description}
          </Text>
        ) : null}
      </Box>

      <Box flex="1">{children}</Box>

      <Box mt="auto">
        <Button
          type="button"
          w="100%"
          height="44px"
          padding="13px 16px"
          borderRadius="100px"
          border={isActionDisabled ? "1px solid #E9E9E9" : "1px solid #2F80ED"}
          bgColor="#2F80ED"
          color="#FFF"
          fontSize="16px"
          lineHeight="14px"
          fontWeight="600"
          isLoading={isPrimaryLoading}
          isDisabled={isActionDisabled}
          _disabled={{
            backgroundColor: "#E9E9E9 !important",
            borderColor: "#E9E9E9",
          }}
          _hover={
            isActionDisabled
              ? undefined
              : {
                  bgColor: "#fff !important",
                  color: "#2F80ED",
                  border: "1px solid #2F80ED",
                }
          }
          onClick={onPrimary}
          transition="all 0.2s"
          display={{ base: "none", md: "flex" }}
        >
          {primaryLabel}
        </Button>
      </Box>
      <Flex align="center" gap="12px" display={{ base: "none", md: "flex" }}>
        <Box as="img" src={lockIcon} w="36px" h="36px" />
        <Text fontSize="14px" color="#505E70">
          Your files and data are 100% secure. All uploaded files are encrypted
          & confidential.
        </Text>
      </Flex>
    </Flex>
  );
}
